import { Check } from "lucide-react";
import { SectionHeading } from "../components/SectionHeading";
import { Reveal } from "../components/Reveal";
import { QUALITY_POINTS, IMAGES } from "../data/site";

export const Quality = () => (
  <section data-testid="quality-section" className="relative bg-brand-coal py-24 sm:py-32 overflow-hidden">
    <div className="absolute inset-0">
      <img src={IMAGES.steelTexture} alt="" aria-hidden="true" className="w-full h-full object-cover opacity-15" />
      <div className="absolute inset-0 bg-gradient-to-b from-brand-coal/70 to-brand-coal" />
    </div>
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading
        dark
        kicker="Quality & Trust"
        title={
          <>
            Quality You Can See.
            <br />
            <span className="text-brand-red">Strength You Can Trust.</span>
          </>
        }
      />
      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-0 max-w-4xl">
        {QUALITY_POINTS.map((q, i) => (
          <Reveal key={q} delay={i * 0.05}>
            <div
              data-testid={`quality-point-${i}`}
              className="flex items-center gap-4 py-5 border-b border-white/10 group"
            >
              <span className="w-8 h-8 shrink-0 border border-brand-red flex items-center justify-center group-hover:bg-brand-red transition-colors duration-300">
                <Check className="w-4 h-4 text-brand-red group-hover:text-white transition-colors duration-300" strokeWidth={3} />
              </span>
              <span className="font-display text-base sm:text-lg font-medium uppercase tracking-wider text-white">
                {q}
              </span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
